import { render, staticRenderFns } from "./dragFileUpload.vue?vue&type=template&id=7fc71690"
import script from "./dragFileUpload.vue?vue&type=script&lang=js"
export * from "./dragFileUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports